import 'core-js/stable';
import 'regenerator-runtime/runtime';
import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import "./assets/scss/app.scss";
import { extend, localize } from "vee-validate";
import * as rules from "vee-validate/dist/rules";
import pt_BR from "vee-validate/dist/locale/pt_BR";
import VueGtm from "@gtm-support/vue2-gtm";
import VueFacebookPixel from '@blaaat/vue-facebook-pixel';
import VueGtag from 'vue-gtag';
import { initSafariFixes } from './utils/safari-fixes';
import { initErrorHandling } from './utils/error-handler';

import filtros from "./filtros.js";
import mixins from "@/mixins/mixins"

import axios from './services/axiosAdmin';
import VCalendar from 'v-calendar';

// Initialize Safari fixes and error handling early
initSafariFixes();
initErrorHandling();

let subdominio = process.env.VUE_APP_STANDARD_PARTNER;
if (window.location.host.includes("portalexecutivarecuperacao")) {
    subdominio = "executiva";
} else if (window.location.host.split(".")[0] == 'www' && window.location.host.split(".")[1] != 'aquicob') {
    subdominio = window.location.host.split(".")[1];
} else if (window.location.host.split(".").length > 2) {
    subdominio = window.location.host.split(".")[0] === "www" ? process.env.VUE_APP_STANDARD_PARTNER : window.location.host.split(".")[0];
}

if (window.location.host == 'negocie.acertebem.com.br') {
    subdominio = 'acertebem';
}

if (window.location.host == 'negociar.senff.com.br') {
    subdominio = 'senff';
}

if (window.location.host.includes("acerteaqui.com")) {
    subdominio = "aq";
}

if (subdominio === "senff") {
    document.title = "Senff | Seguro, rápido e online!";
}

// Function to initialize Vue app with fallback
function initializeVueApp(partnerData = null) {
    try {
        // Set default partner config if none provided
        if (!partnerData) {
            store.commit('SET_PARCEIRO_CONFIG', {
                nome: 'Aquicob',
                identificador: 'aquicob',
                estilo: {
                    corPrimaria: '#00c0fb',
                    corSecundaria: '#5938c8'
                },
                sessoes: {
                    header: null,
                    about: null,
                    partners: null,
                    contact: null,
                    tutorial: null,
                    creditor: true,
                    logoForBackgroundWhite: null,
                    customization: null,
                    omniChannel: null
                }
            });
        }

        // Initialize Vue with minimal config
        new Vue({
            router,
            store,
            render: (h) => h(App),
        }).$mount("#app");
    } catch (error) {
        console.error('Vue initialization failed:', error);
        // Final fallback: show basic content
        document.getElementById('app').innerHTML = `
            <div style="padding: 20px; text-align: center; font-family: Arial, sans-serif;">
                <h1>Erro ao carregar a aplicação</h1>
                <p>Por favor, atualize a página ou tente novamente mais tarde.</p>
                <button onclick="window.location.reload()" style="padding: 10px 20px; margin-top: 10px;">
                    Recarregar página
                </button>
            </div>
        `;
    }
}

// Make API request with timeout and retry
const makeApiRequest = async (retryCount = 0) => {
    try {
        const response = await axios.get(`/api/parceiro/` + subdominio + `/info`, {
            timeout: 15000 // 15 seconds timeout
        });
        return response;
    } catch (error) {
        console.warn(`API request failed (attempt ${retryCount + 1}):`, error.message);
        
        // Retry up to 2 times for network errors
        if (retryCount < 2 && (error.code === 'ECONNABORTED' || error.message === 'Request aborted' || !error.response)) {
            console.log(`Retrying API request... (${retryCount + 1}/2)`);
            await new Promise(resolve => setTimeout(resolve, 2000)); // Wait 2 seconds
            return makeApiRequest(retryCount + 1);
        }
        
        throw error;
    }
};

makeApiRequest().then((resposta) => {
    if (resposta.data.data) {
        store.state.portalCamec = resposta.data.data.emp_codigo == 350;

        let header = resposta.data.data.sessoes.find((sessao) => sessao.nome === "header");
        let about = resposta.data.data.sessoes.find((sessao) => sessao.nome === "about");
        let partners = resposta.data.data.sessoes.find((sessao) => sessao.nome === "partners");
        let contact = resposta.data.data.sessoes.find((sessao) => sessao.nome === "contact");
        let tutorial = resposta.data.data.sessoes.find((sessao) => sessao.nome === "tutorial");
        let logoForBackgroundWhite = resposta.data.data.sessoes.find((sessao) => sessao.nome === "logoForBackgroundWhite");
        let customization = resposta.data.data.sessoes.find((sessao) => sessao.nome === "customization");
        let omniChannel = resposta.data.data.sessoes.find((sessao) => sessao.nome === "omniChannel");

        if (subdominio == "aquicob") {
            resposta.data.data.sessoes = {
                header: header,
                about: about,
                partners: partners,
                contact: contact,
                tutorial: tutorial,
                creditor: true,
                logoForBackgroundWhite: logoForBackgroundWhite,
                customization: customization,
                omniChannel: omniChannel
            };

        } else {
            resposta.data.data.sessoes = {
                header: header,
                about: about,
                partners: partners,
                contact: contact,
                tutorial: tutorial,
                creditor: null,
                logoForBackgroundWhite: logoForBackgroundWhite,
                customization: customization,
                omniChannel: omniChannel
            };
        }

        store.state.nomeParceiroContratos = resposta.data.data.sessoes.customization.campos.landPage.textNomeParceiroContratos != '' &&
            resposta.data.data.sessoes.customization.campos.landPage.textNomeParceiroContratos != null &&
            resposta.data.data.sessoes.customization.campos.landPage.textNomeParceiroContratos != undefined ?
            resposta.data.data.sessoes.customization.campos.landPage.textNomeParceiroContratos : 'Aquicob';

        store.commit('SET_PARCEIRO_CONFIG', resposta.data.data);

        if (resposta?.data?.data?.hotjar_id != null) {
            try {
                Vue.use(Hotjar, {
                    id: resposta?.data?.data?.hotjar_id
                });
            } catch (error) {
                console.warn('Hotjar initialization failed:', error);
            }
        }

        store.commit('SET_COR_PRIMARIA', {
            "--color": resposta.data.data.estilo.corPrimaria,
            "--hoverColor": resposta.data.data.estilo.corSecundaria
        });

        store.commit('SET_COR_SECUNDARIA', {
            "--color": resposta.data.data.estilo.corSecundaria,
            "--hoverColor": resposta.data.data.estilo.corPrimaria
        });

        store.commit('CHANGE_MESSAGE_SNACKBAR', '');

        if (resposta.data.data.identificador === "aqui") {
            document.title = "Negociar on-line";

            document.querySelector("link[rel='icon']").href = document.baseURI + "logo-negociar.png"
        }

        try {
            Vue.use(VueGtm, {
                id: "GTM-N58G92Z",
                enabled: true,
                debug: false,
                vueRouter: router,
            });
        } catch (error) {
            console.warn('GTM initialization failed:', error);
        }

        Vue.use(VCalendar, {
            componentPrefix: 'v',
        });

        if (
            resposta.data.data.measurance_id_google != null &&
            resposta.data.data.measurance_id_google != undefined &&
            resposta.data.data.measurance_id_google.trim() != ''
        ) {
            try {
                Vue.use(VueGtag, {
                    config: { id: resposta.data.data.measurance_id_google }
                });
            } catch (error) {
                console.warn('Google Analytics initialization failed:', error);
            }
        }

        if (resposta.data.data.pixel_meta != null && resposta.data.data.pixel_meta != undefined && resposta.data.data.pixel_meta.trim() != '') {
            try {
                !function (f, b, e, v, n, t, s) {
                    if (f.fbq) return; n = f.fbq = function () {
                        n.callMethod ?
                            n.callMethod.apply(n, arguments) : n.queue.push(arguments)
                    };
                    if (!f._fbq) f._fbq = n; n.push = n; n.loaded = !0; n.version = '2.0';
                    n.queue = []; t = b.createElement(e); t.async = !0;
                    t.src = v; s = b.getElementsByTagName(e)[0];
                    s.parentNode.insertBefore(t, s)
                }(window, document, 'script',
                    'https://connect.facebook.net/en_US/fbevents.js');

                Vue.use(VueFacebookPixel);
                Vue.analytics.fbq.init(resposta.data.data.pixel_meta, {
                    em: 'user@mail.com'
                });
            } catch (error) {
                console.warn('Facebook Pixel initialization failed:', error);
            }
        }

        Object.keys(rules).forEach((rule) => {
            extend(rule, rules[rule]);
        });

        localize("pt_BR", pt_BR);

        Vue.config.productionTip = false;

        Vue.filter("formatarData", filtros.formatarData);

        Vue.filter("formatarDinheiro", filtros.formatarDinheiro);

        Vue.filter("formatarCpf", filtros.formatarCpf);

        Vue.filter("formatarCpfCnpj", filtros.formatarCpfCnpj);

        Vue.mixin(mixins);

        initializeVueApp(resposta.data.data);
    } else {
        console.error('No partner data received from API');
        // Fallback: initialize Vue with minimal config
        initializeVueApp();
    }
}).catch((error) => {
    console.error('Error loading partner config:', error);
    // Fallback: initialize Vue with minimal config even if API fails
    initializeVueApp();
});
